import { motion } from "framer-motion";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaGithub,
  FaLinkedin,
  FaWhatsapp,
  FaPaperPlane,
} from "react-icons/fa";

import SectionTitle from "../ui/SectionTitle";

export default function Contact() {
  return (
    <section
      id="contact"
      className="section relative overflow-hidden bg-[#07101f]"
    >
      {/* Background */}

      <div className="absolute left-0 top-0 h-96 w-96 rounded-full bg-blue-600/10 blur-[140px]" />

      <div className="absolute right-0 bottom-0 h-96 w-96 rounded-full bg-cyan-500/10 blur-[140px]" />

      <div className="container">

        <SectionTitle
          subtitle="Contact"
          title="Let's Build Something Amazing"
        />

        <div className="grid gap-16 lg:grid-cols-2">

          {/* LEFT */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >

            <h3 className="text-4xl font-bold leading-tight">

              Ready to start your next project?

            </h3>

            <p className="mt-8 text-lg leading-8 text-slate-400">

              Whether you need a React application,
              Next.js website, WordPress solution,
              ecommerce store or a complete redesign,
              I'd love to discuss your project.

            </p>

            <div className="mt-12 space-y-6">

              <div className="flex items-center gap-5 rounded-2xl border border-white/10 bg-white/5 p-6">

                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-600 text-xl">

                  <FaEnvelope />

                </div>

                <div>

                  <p className="text-slate-400">

                    Email

                  </p>

                  <h4 className="font-semibold">

                    me@moobeenquader.com

                  </h4>

                </div>

              </div>

              <div className="flex items-center gap-5 rounded-2xl border border-white/10 bg-white/5 p-6">

                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-600 text-xl">

                  <FaPhoneAlt />

                </div>

                <div>

                  <p className="text-slate-400">

                    Phone

                  </p>

                  <h4 className="font-semibold">

                    +92 332 235 1994

                  </h4>

                </div>

              </div>

              <div className="flex items-center gap-5 rounded-2xl border border-white/10 bg-white/5 p-6">

                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-600 text-xl">

                  <FaMapMarkerAlt />

                </div>

                <div>

                  <p className="text-slate-400">

                    Location

                  </p>

                  <h4 className="font-semibold">

                    Karachi, Pakistan

                  </h4>

                </div>

              </div>

            </div>

            {/* Social */}

            <div className="flex gap-5 mt-12">

              <a
                href="https://github.com/"
                className="h-14 w-14 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-blue-600 duration-300"
              >
                <FaGithub />
              </a>

              <a
                href="https://linkedin.com/"
                className="h-14 w-14 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-blue-600 duration-300"
              >
                <FaLinkedin />
              </a>

              <a
                href="https://wa.me/"
                className="h-14 w-14 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-green-600 duration-300"
              >
                <FaWhatsapp />
              </a>

            </div>

          </motion.div>

          {/* RIGHT */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >

            <form className="rounded-[35px] border border-white/10 bg-white/5 p-10 backdrop-blur-xl">

              <div className="grid gap-6">

                <input
                  type="text"
                  placeholder="Your Name"
                  className="rounded-xl border border-white/10 bg-transparent px-6 py-4 outline-none focus:border-blue-500"
                />

                <input
                  type="email"
                  placeholder="Email Address"
                  className="rounded-xl border border-white/10 bg-transparent px-6 py-4 outline-none focus:border-blue-500"
                />

                <input
                  type="text"
                  placeholder="Subject"
                  className="rounded-xl border border-white/10 bg-transparent px-6 py-4 outline-none focus:border-blue-500"
                />

                <textarea
                  rows="6"
                  placeholder="Tell me about your project..."
                  className="rounded-xl border border-white/10 bg-transparent px-6 py-4 outline-none focus:border-blue-500 resize-none"
                />

                <button
                  className="flex items-center justify-center gap-3 rounded-xl bg-blue-600 py-5 font-semibold transition hover:bg-blue-700"
                >

                  Send Message

                  <FaPaperPlane />

                </button>

              </div>

            </form>

          </motion.div>

        </div>

        {/* CTA */}

        <div className="mt-24 rounded-[35px] border border-blue-500/20 bg-gradient-to-r from-blue-600/20 to-cyan-500/20 p-10 text-center">

          <h3 className="text-4xl font-bold">

            Available for Freelance & Remote Opportunities

          </h3>

          <p className="mt-6 max-w-3xl mx-auto text-slate-300 leading-8">

            I'm always interested in working with startups,
            agencies and businesses looking for modern,
            high-performance web applications built with
            React, Next.js and WordPress.

          </p>

        </div>

      </div>

    </section>
  );
}